import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
 
import './css/App.css';
import './css/index.css';
import './css/new.css';
import './css/section.css';
import './css/style.css';
import './css/responsive.css';
import './css/theme.css'; 


import Layout from './components/Layout';
import Register from "./components/Register";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Head from "./components/Head";


import About from './pages/About';
import StarHealthPolicy from './pages/StarHealthPolicy';
import ForgotPassword from "./components/ForgotPassword";
import Health from "./pages/Health";
import General from "./pages/General";
import Life from "./pages/Life";
import Pos from "./pages/Pos";
import Apply from "./pages/Apply";
import OurMember from "./pages/OurMember";
import SanjeevPeofile from "./pages/SanjeevPeofile";
import GetApplyLeads from "./components/GetApplyLeads";
import Contactus from "./components/Contactus";
import AdminMessages from "./pages/AdminMessages";
import AIWidget from "./ai-assistant";



function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Head />
        <Navbar />
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/About" element={<About />} />
           <Route path="/Contactus" element={<Contactus />} />
          <Route path="/StarHealthPolicy" element={<StarHealthPolicy />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/Health" element={<Health />} />
          <Route path="/General" element={<General />} />
          <Route path="/Life" element={<Life />} />
          <Route path="/Pos" element={<Pos />} />
          <Route path="/Apply" element={<Apply />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
          <Route path="/OurMember" element={<OurMember />} />
          <Route path="/SanjeevPeofile" element={<SanjeevPeofile />} />
          <Route path="/GetApplyLeads"  element={<GetApplyLeads />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
         <AIWidget />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;


